;(function (angular, numeral) {
  'use strict'

  angular
    .module('kilo.common.filters')
    .filter('status', StatusFilter)

  StatusFilter.$inject = ['StatusService']

  function StatusFilter (StatusService) {
    return function (type, input) {
      return StatusService.getLabel(type, input)
    }
  }
})(window.angular, window.numeral)
